import React from 'react';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { MantineProvider } from '@mantine/core';
import { theme } from './theme';
import { BrowserRouter as Router } from 'react-router-dom';
import { RouteUtils } from '@bobex/react-core/routes/RouteUtils';
import AllRoutes from '@/routes/RoutesMatcher';
import './i18n';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { ModalsProvider } from '@mantine/modals';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/nl-be.js';
import '@mantine/tiptap/styles.css';

import { DatesProvider } from '@mantine/dates';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { SidebarProvider } from '@/components/Sidebar/SidebarProvider';
import Login from '@/pages/Login/Login';
import AppLayout from '@/components/Layout/AppLayout';
import { protectedRoutes } from '@/configs/routes.config';

// Component that uses heartbeat inside Router context
// function AppWithHeartbeat() {
//     useHeartbeat();
//     return null;
// }

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <MantineProvider theme={theme}>
        <SidebarProvider>
          <Notifications position={'top-right'} />
          <ModalsProvider />
          <DatesProvider settings={{ locale: i18n.language }}>
            <Router basename={RouteUtils.getBasename()}>
              <AllRoutes
                loginPage={<Login />}
                appLayout={AppLayout}
                protectedRoutes={protectedRoutes}
                authenticatedEntryPath={RouteUtils.redirectToHomePage()}
              />
              {/*<AppWithHeartbeat/>*/}
            </Router>
          </DatesProvider>
        </SidebarProvider>
      </MantineProvider>
    </I18nextProvider>
  );
}

export default App;
